module.exports = __webpack_public_path__ + "images/ca764539c8747d67cd22624612156a8611c2e9e30b442ffddece13814c87d317.svg";